import logEvent from "lib/ga/miscEvent";
import logSearchPageFilter from "lib/ga/searchPageFilter";
import TEXT from "localisation";
import styles from './advancedFilters.module.css'
import { KeyboardEvent } from "react";
const googleEvents = (location: string, value: object, filterLabel: string) => {
    logEvent({
        category: "Flexible Search",
        action: "Filter Applied",
        label: `Location: ${location}, Filter: ${filterLabel}, Value: ${JSON.stringify(value)}`,
    });

    logSearchPageFilter({
        filter: filterLabel,
        value: JSON.stringify(value),
        state: "add",
    });
}

type PageProps = {
    label: string,
    options: any,
    values: any,
    onSelect: any,
    onRemove: any,
    location: string,
    border?: boolean,
    lableLookUp?: string,
    showMore: boolean,
    onMoreClick: any,
    onSearch: any,
    showSearch: boolean,
    defaultOptions?: any,
    defaultAllTrue?: boolean,
    setFilter: any,
    field: string,
    includeUiOption?: boolean,
    searchPlaceholder: string
};

const CheckboxFiliter = ({ label, includeUiOption, field, options, setFilter, defaultOptions, defaultAllTrue = false, values, onSelect, onRemove, location, border, lableLookUp, showMore, onMoreClick, onSearch, showSearch, searchPlaceholder }: PageProps) => {

    const filteredOptions = defaultOptions ? options.filter(x => defaultOptions.includes(x.value)) : options

    const handleChange = (e) => {
        const newValue = values;
        const index = values.indexOf(e.target.value);
        if (index > -1) {
            values.splice(index, 1);
            onRemove(e.target.value);
            googleEvents(location, newValue, label);
            if (values.length === 0 && includeUiOption) {
                setFilter(`ui:${field === 'availability' ? 'availability' : 'category_code'}`, 'all', 'all')
            }
        } else {
            newValue.push(e.target.value)
            onSelect(e.target.value);
            googleEvents(location, newValue, label);
        }
    }


    return (
        <div className={styles.borderTop}>
            <p className={styles.checkboxHeading}>{label}</p>
            <section className={border ? ` ${styles.border} ${styles.selectExternalContainer} ${styles.paddingx}` : `${styles.selectExternalContainer} ${styles.paddingx}`}>

                {showSearch && (
                    <input className="textSearch" placeholder={searchPlaceholder} onKeyUp={
                        (e: KeyboardEvent<HTMLInputElement>) => {
                            onSearch(e.currentTarget.value)
                        }
                    } />
                )}


                {filteredOptions.map((option, index) => {
                    return (
                        <section className={styles.selectContainer} key={option.value}>
                            <input type="checkbox" id={option.value} name={option.value} value={option.value}
                                checked={values.includes(option.value)}
                                onChange={(e) => {
                                    handleChange(e)
                                }} />
                            <label htmlFor={option.value}> {lableLookUp ? TEXT[`${lableLookUp}${option.value}`] : option.value}</label>

                        </section>
                    )
                })}

                {showMore && (
                    <button className={styles.showMoreButton} onClick={(e) => {
                        onMoreClick()
                    }}>Show more</button>
                )}

            </section>
        </div>
    )
}


export default CheckboxFiliter;